import { filterNotEmpty } from '@beeline.com/bp-design-system';
import { stringUtil } from './stringUtil';

export const DEFAULT_MULTI_VALUE_SEPARATOR = ',';

export function normalizeMultiValue(
  value: string | undefined,
  separator: string = DEFAULT_MULTI_VALUE_SEPARATOR
): string[] | undefined {
  if (!value || value === ' ') {
    return undefined;
  }
  const tempValue = stringUtil.escapedToSafe(value);
  return filterNotEmpty(
    tempValue?.split(separator).map((v) => {
      return stringUtil.safeToEscaped(v.trim());
    })
  );
}
